import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { UcrSecurityService } from '../core/ucr-security/ucr-security.service';
import { environment } from '../../environments/environment';
import { UserInfo } from '../core/ucr-security/user-info';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    constructor(private router: Router, private route: ActivatedRoute, private ucrSecurity: UcrSecurityService) {
        this.ucrSecurity.getUserInfo(true).subscribe((ui: UserInfo) => {
            if (!ui.username) {
                window.location.href = `${environment.serverUrl}/`;
            } else {
                if (ui.authorities.length === 0) {
                    this.router.navigate(['notAuthorized']);
                } else {
                    this.ucrSecurity.isLoggedIn = true;
                    this.router.navigate(['home']);
                }
            }
        });
    }

    ngOnInit(): void {
        //
    }
}
